import React from 'react';

function Hero() {
  return (
    <div
      className="relative min-h-screen flex items-center justify-center text-white overflow-hidden"
      style={{
        backgroundImage: 'url(/images/agri-dagi.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark Overlay - Şeffaflaştırıldı */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#000428]/40 via-[#004e92]/30 to-[#000428]/40"></div>

      {/* Animated Background Circles */}
      <div className="absolute w-64 h-64 bg-gradient-to-br from-cyan-400/20 to-blue-600/20 rounded-full blur-3xl animate-pulse" style={{ top: '10%', left: '20%' }}></div>
      <div className="absolute w-80 h-80 bg-gradient-to-br from-purple-400/20 to-pink-600/20 rounded-full blur-3xl animate-pulse delay-1000" style={{ bottom: '10%', right: '15%' }}></div>

      {/* Content */}
      <h1 className="relative z-10 text-4xl md:text-6xl lg:text-7xl font-extrabold text-center px-6 animate-fadeInUp bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600">
        ACM IĞDIR'A HOŞ GELDİNİZ!
      </h1>
    </div>
  );
}

export default Hero;
